import { GetProductResponse } from "types/products";
import { ProductFormTypes } from "../components/ProductForm/types";
import { StatusType } from "types/common";
import { valueType } from "antd/es/statistic/utils";
import { fixedDigitsValue } from "helpers/dataHelpers";

export const calculateDiscountPrice = (price: string, discount: valueType) => {
  const priceValue = Number(price);

  const discountValue = (priceValue * 1000 * Number(discount)) / 100 / 1000;

  const discountPrice = priceValue - discountValue;

  return fixedDigitsValue(discountPrice, 2).toString();
};

export const createInitialData = (
  productData: GetProductResponse,
): ProductFormTypes => {
  const {
    id,
    companyId,
    createdAt,
    updatedAt,
    highlights,
    alergents,
    ...data
  } = productData;

  const highlightsValues = {};
  const alergentsValues = {};

  highlights?.forEach(tag => (highlightsValues[tag.id] = true));
  alergents?.forEach(tag => (alergentsValues[tag.id] = true));

  return {
    ...data,
    name2: data?.name2 || null,
    externalFiatPrice: data?.externalFiatPrice || "0",
    labels: data?.labels[0]?.id || "",
    status: data.status === StatusType.Active ? "active" : "disabled",
    highlights: highlightsValues,
    alergents: alergentsValues,
    discountPercentages: data?.discountPercentages || "0",
    discountPrice: data?.discountPercentages
      ? calculateDiscountPrice(
          data?.price || "0",
          data?.discountPercentages || 0,
        )
      : data?.price || "0",
  };
};

export const getRequestTagsData = (
  selectedTags: Record<string, boolean | undefined>,
): string[] => {
  const tagIds = Object.keys(selectedTags).filter(
    key => selectedTags[key] === true,
  );

  if (!tagIds.length) {
    return [];
  }

  return tagIds;
};
